// src/pages/Dashboard.js
import { XMarkIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";
import Navbar from "../common/components/NavBar";
import StageForm from "../components/Dashboard/StageForm";
import StageTable from "../components/Dashboard/StageTable";

function PageDrawer({ title, onClose, children }) {
  return (
    <div className="fixed inset-0 z-40">
      <button
        type="button"
        className="absolute inset-0 bg-slate-950/25 backdrop-blur-[2px]"
        onClick={onClose}
        aria-label="Close page drawer"
      />
      <aside className="absolute right-0 top-0 flex h-full w-full max-w-xl flex-col border-l border-slate-200 bg-white shadow-2xl sm:w-[560px]">
        <div className="flex items-center justify-between border-b border-slate-200 px-5 py-4">
          <h2 className="text-xl font-semibold tracking-tight text-slate-950">
            {title}
          </h2>
          <button
            type="button"
            className="secondary-button px-3"
            onClick={onClose}
            aria-label="Close page drawer"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto p-5 sm:p-6">
          {children}
        </div>
      </aside>
    </div>
  );
}

export default function Dashboard() {
  const [isCreateFormOpen, setIsCreateFormOpen] = useState(false);
  const [editingStage, setEditingStage] = useState(null);

  const openCreateForm = () => {
    setEditingStage(null);
    setIsCreateFormOpen(true);
  };

  const openEditForm = (stage) => {
    setIsCreateFormOpen(false);
    setEditingStage(stage);
  };

  return (
    <div className="app-shell">
      <Navbar />

      <main className="page-container">
        <section className="surface-panel min-w-0 overflow-hidden p-0">
          <StageTable onCreateClick={openCreateForm} onEditClick={openEditForm} />
        </section>
      </main>

      {isCreateFormOpen && (
        <PageDrawer title="Create page" onClose={() => setIsCreateFormOpen(false)}>
          <StageForm onCreated={() => setIsCreateFormOpen(false)} />
        </PageDrawer>
      )}

      {editingStage && (
        <PageDrawer title="Edit page" onClose={() => setEditingStage(null)}>
          <StageForm
            initialEvent={editingStage}
            onSaved={() => setEditingStage(null)}
          />
        </PageDrawer>
      )}
    </div>
  );
}
